import { render, staticRenderFns } from "./prepaid.vue?vue&type=template&id=36748e68&"
import script from "./prepaid.vue?vue&type=script&lang=js&"
export * from "./prepaid.vue?vue&type=script&lang=js&"
import style0 from "./prepaid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports